import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RegressionContainer from '../Containers/RegressionContainer';
import InstallerTestExpectedModalContainer
  from '../Containers/InstallerTestExpectedModalContainer';
import InstallerTestScenariosModalContainer
  from '../Containers/InstallerTestScenariosModalContainer';
import { modal as modalActions } from '../actions';
import { connect } from 'react-redux';
import { getSearch } from './../reducers';
import { Button, Row, Col, Panel } from 'react-bootstrap';
import InstallerTestExpectedContainer from './InstallerTestExpectedContainer';

export class InstallerTestsContainer extends Component {
  static propTypes = {
    search: PropTypes.string.isRequired,
    showTestsExpectedModal: PropTypes.func.isRequired
  };

  render() {
    const jobSelected = this.props.search.includes('nb=');
    return (
      <div>
        <RegressionContainer hasCommenting />
        {
          jobSelected ?
            <div>
              <InstallerTestScenariosModalContainer />
              <InstallerTestExpectedModalContainer />
              <Row style={{ margin: 0 }}>
                <Col md={8} mdOffset={2} style={{ padding: 0 }}>
                  <Row style={{ marginBottom: '15px' }}>
                    <div>
                      <Button onClick={this.props.showTestsExpectedModal}>
                        Show Expected Tests
                      </Button>
                      <Panel>
                        <InstallerTestExpectedContainer requiresAck />
                      </Panel>
                    </div>
                  </Row>
                </Col>
              </Row>
            </div> : null
        }
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return { search: getSearch(state) };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    showTestsExpectedModal: () =>
      dispatch(modalActions.showTestsExpectedModal(true))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstallerTestsContainer);


// WEBPACK FOOTER //
// src/Containers/InstallerTestsContainer.jsx